export default {
      id: "social-04-usage",
      viewBox: "0 0 22 16",
      url: __webpack_public_path__ + "assets/img/svg/sprite.svg#social-04",
      toString: function () {
        return this.url;
      }
    }